export default __webpack_public_path__ + "static/media/pHSensorsImg.8cfaa975.jpg";